import { atom } from 'recoil';

export const SummaryDirectionState = atom({
    key: 'SummaryDirectionState', 
    default: null, 
});